const seedlingsList = [
    {
        "id": "tohum1",
        "name": "Sebze Fideleri",
        "image": "https://github.com/RealCodeMate/SoydanTarim/blob/main/soydantarim/src/assets/galleryImg/fide.jpg?raw=true",
        "info": ""
    },
]

export default seedlingsList; 